<div class="w-full h-full pb-40">
    <app-tab-header [tabs]="tabs"></app-tab-header>

    <div class="flex flex-row gap-10 flex-wrap justify-center">

        <!-- CASHOUT TOGGLE SETTINGS WINDOW -->
        <div style="width: fit-content; align-self: flex-start;" class="mt-20 border-gray-400 b-orange">
            <header class="flex justify-center align-center p-2 b-orange-bottom font-bold orange-text">
                <h2>CASHOUT SETTINGS</h2>
            </header>

            <div class="flex flex-col gap-3 p-4">

                <!-- STATUS ROW -->
                <div class="flex items-center gap-3">
                    <span class="text-xs w-70-px font-semibold">Status:</span>
                    <div class="card-input flex items-center w-250-px">
                        <input 
                            *ngIf="isLoading" 
                            disabled
                            class="bg-gray-100 italic text-gray-500 cursor-wait focus:outline-none w-full h-30-px rounded-md pl-3"
                            type="text" value="Loading..."
                        >
                        <ng-container *ngIf="!isLoading">
                            <app-dropdown-field
                                [options]="killSwitchOptions"
                                [selectedText]="killSwitchText"
                                placeholder="== Select Status =="
                                (selectionChange)="onKillSwitchChange($event)">
                            </app-dropdown-field>
                        </ng-container>
                    </div>
                    <ng-container *ngIf="!isLoading">
                        <span
                            [matTooltip]="killSwitchUnchanged ? 'Select a different status first to enable saving.' : ''"
                            matTooltipPosition="right">
                            <button
                                (click)="saveKillSwitch()"
                                [disabled]="isLoading || killSwitchUnchanged"
                                [class.opacity-50]="killSwitchUnchanged"
                                [class.cursor-not-allowed]="killSwitchUnchanged"
                                class="uppercase power-btn2 active custom-btn font-semibold px-6 py-2">
                                Save
                            </button>
                        </span>
                    </ng-container>
                </div>

                <!-- MODE ROW -->
                <div class="flex items-center gap-3">
                    <span class="text-xs w-70-px font-semibold">Mode:</span>
                    <div class="card-input flex items-center w-250-px">
                        <input *ngIf="isLoading" disabled
                            class="bg-gray-100 italic text-gray-500 cursor-wait focus:outline-none w-full h-30-px rounded-md pl-3"
                            type="text" value="Loading...">
                        <ng-container *ngIf="!isLoading">
                            <app-dropdown-field
                                [options]="approvalModeOptions"
                                [selectedText]="approvalModeText"
                                placeholder="== Select Mode =="
                                (selectionChange)="onApprovalModeChange($event)">
                            </app-dropdown-field>
                        </ng-container>
                    </div>
                    <ng-container *ngIf="!isLoading">
                        <span
                            [matTooltip]="approvalModeUnchanged ? 'Select a different mode first to enable saving.' : ''"
                            matTooltipPosition="right">
                            <button
                                (click)="saveApprovalMode()"
                                [disabled]="isLoading || approvalModeUnchanged"
                                [class.opacity-50]="approvalModeUnchanged"
                                [class.cursor-not-allowed]="approvalModeUnchanged"
                                class="uppercase power-btn2 active custom-btn font-semibold px-6 py-2">
                                Save
                            </button>
                        </span>
                    </ng-container>
                </div>

            </div>
        </div>

        <!-- CASHOUT LIMITS WINDOW -->
        <div style="width: 650px; align-self: flex-start;" class="mt-20 border-gray-400 b-orange">

            <!-- HEADER with inline tier dropdown -->
            <header class="flex justify-between items-center px-4 py-2 b-orange-bottom font-bold orange-text gap-6">
                <h2>CASHOUT LIMITS</h2>
                <div class="card-input flex items-center w-220-px font-normal" style="border: 1px #E1742E solid; border-radius: 0px;">
                    <input 
                        *ngIf="isLoadingTiers" 
                        disabled
                        class="bg-gray-100 italic text-gray-500 cursor-wait focus:outline-none w-full h-30-px rounded-md pl-3"
                        type="text" value="Loading..."
                    >
                    <ng-container *ngIf="!isLoadingTiers">
                        <app-dropdown-field
                            [options]="tierOptions"
                            [selectedText]="selectedTierLabel"
                            placeholder="== Select Tier =="
                            [openArrowClass]="'violet-text'"
                            [closeArrowClass]="'orange-text'"
                            [textClass]="'orange-text'"
                            style="font-weight: bold;"
                            (selectionChange)="onTierChange($event)">
                        </app-dropdown-field>
                    </ng-container>
                </div>
            </header>

            <div class="flex flex-col gap-3 p-4">

                <span
                    [matTooltip]="selectedTierId === null ? 'Please select a tier first.' : ''"
                    matTooltipPosition="above">

                    <ng-container *ngIf="selectedTierId === null">
                        <div class="w-full py-8"></div>
                    </ng-container>

                    <ng-container *ngIf="selectedTierId !== null">

                        <!-- MIN PER TRANSACTION -->
                        <div class="mb-3">
                            <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="">
                                <span class="text-xs w-160-px font-semibold">Min Per Transaction:</span>
                                <input
                                    class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                                    type="number" min="0" placeholder="Enter amount"
                                    [(ngModel)]="limitForm.minAmountPerTransaction"
                                    [disabled]="isLoadingLimits"
                                    appOnlyNumber [allowDecimal]="true"
                                >
                            </div>
                        </div>

                        <!-- MAX PER TRANSACTION -->
                        <div class="mb-3">
                            <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="">
                                <span class="text-xs w-160-px font-semibold">Max Per Transaction:</span>
                                <input
                                    class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                                    type="number" min="0" placeholder="Enter amount"
                                    [(ngModel)]="limitForm.maxAmountPerTransaction"
                                    [disabled]="isLoadingLimits"
                                    appOnlyNumber [allowDecimal]="true"
                                >
                            </div>
                        </div>

                        <!-- DAILY LIMIT -->
                        <div class="mb-3">
                            <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="">
                                <span class="text-xs w-160-px font-semibold">Daily Limit:</span>
                                <input
                                    class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                                    type="number" min="0" placeholder="Enter amount"
                                    [(ngModel)]="limitForm.dailyLimitAmount"
                                    [disabled]="isLoadingLimits"
                                    appOnlyNumber [allowDecimal]="true"
                                    >
                            </div>
                        </div>

                        <!-- MONTHLY LIMIT -->
                        <div class="mb-3">
                            <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="">
                                <span class="text-xs w-160-px font-semibold">Monthly Limit:</span>
                                <input
                                    class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                                    type="number" min="0" placeholder="Enter amount"
                                    [(ngModel)]="limitForm.monthlyLimitAmount"
                                    [disabled]="isLoadingLimits"
                                    appOnlyNumber [allowDecimal]="true"
                                >
                            </div>
                        </div>

                        <!-- SAVE BUTTON -->
                        <div class="flex justify-end mt-1">
                            <span
                                [matTooltip]="limitsUnchanged ? 'Modify at least one field to enable saving.' : ''"
                                matTooltipPosition="above">
                                <button
                                    (click)="saveCashoutLimits()"
                                    [disabled]="isLoadingLimits || limitsUnchanged"
                                    [class.opacity-50]="isLoadingLimits || limitsUnchanged"
                                    [class.cursor-not-allowed]="isLoadingLimits || limitsUnchanged"
                                    class="uppercase action-btns active custom-btn font-semibold px-6 py-2">
                                    Submit
                                </button>
                            </span>
                        </div>

                    </ng-container>

                </span>

            </div>
        </div>

    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>